/*
 * @Author: your name
 * @Date: 2020-04-16 14:06:24
 * @LastEditTime: 2020-04-16 14:21:11
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \h5_hot_mall\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'
import 'vant/lib/index.css'
import router from './router.js'
import { AddressEdit, Dialog, Toast } from 'vant'
import urlconfig from './config.js'

import share from './share.js'
import wx from 'weixin-js-sdk'
import Oss from './assets/oss'
import clipboard from 'clipboard' // 复制文本
// localStorage.clear()
localStorage.setItem('isFraud', true)

Vue.use(Oss)

Vue.use(Vant)
Vue.use(AddressEdit)
Vue.prototype.Dialog = Dialog
Vue.prototype.Toast = Toast

Vue.config.productionTip = false

Vue.prototype.imgPath = urlconfig.imgPath
Vue.prototype.ossImgPath = urlconfig.ossImgPath
Vue.prototype.goPath = urlconfig.goPath
Vue.prototype.wxAppId = urlconfig.wxAppId
Vue.prototype.appletsPath = urlconfig.appletsPath
Vue.prototype.DetailUrl = null
Vue.prototype.clipboard = clipboard //复制文本

Vue.prototype.Authorization = function (linkUrl) {
  //微信静默授权     url 跳转路径 bunch需要携带参数值

  let my_path = `${urlconfig.goPath}login`
  let my_url = `${urlconfig.goPath}login?url=` + encodeURIComponent(linkUrl)

  let goUrl = linkUrl ? my_url : my_path

  // console.log(goUrl)

  // 正式
  // let turl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx0745ca56932730e0&redirect_uri=${encodeURIComponent(goUrl)}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`

  let turl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${
    urlconfig.wxAppId
  }&redirect_uri=${encodeURIComponent(
    goUrl
  )}&response_type=code&scope=snsapi_base&state=123#wechat_redirect`
  window.location.href = turl
}

Vue.prototype.showWindowHref = function () {
  //授权成功后获取路由上 code
  let sHref = window.location.href
  let args = sHref.split('?')
  if (args[0] == sHref) {
    return ''
  }
  let arr = args[1].split('&')
  let obj = {}
  for (let i = 0; i < arr.length; i++) {
    let arg = arr[i].split('=')
    obj[arg[0]] = arg[1]
  }
  return obj
}

Vue.prototype.kefuServe = function () {
  qimoChatClick()
}

// 判断是不是在微信端
var ua = navigator.userAgent.toLowerCase()
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
  Vue.prototype.isWexinLogin = true
} else {
  Vue.prototype.isWexinLogin = false
}

router.beforeEach((to, from, next) => {
  console.log(from.name, from.query)
  let myObj = from.query
  let sum = ''
  for (let i in myObj) {
    sum += i + '=' + myObj[i]
    sum += '?'
    // console.log(i)
    // console.log(i + '=' + myObj[i])
  }

  if (to.query.store_id) {
    localStorage.setItem('store_id', to.query.store_id)
  }
  if (to.path != '/shopDetail' && to.path != '/index' && to.path != '/') {
    // console.log(12)
    new share()
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title || ''
  }
  next()
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
